module.exports = __webpack_public_path__ + "img/Store-min.2a33dac7.png";